import * as amplitude from '@amplitude/analytics-browser';
import pkg from '../../package.json';

const isDev = process.env.NODE_ENV !== 'production';

class LoggerClass {
  constructor() {
    if (!process.env.REACT_APP_AMPLITUDE_API_KEY) {
      throw new Error('No Amplitude API Key');
    }

    amplitude
      .init(process.env.REACT_APP_AMPLITUDE_API_KEY, undefined, { minIdLength: 1, appVersion: pkg.version })
      .promise.then(() => {
        if (isDev) {
          console.log('%c[Dev] %cAmplitude has been initialized.', 'color: cyan', 'color: lime');
        }
      });
  }

  track(eventInput: string, eventProperties?: Record<string, any>) {
    amplitude.track(eventInput, eventProperties).promise.then(() => {
      if (isDev) {
        console.log('%c[Dev] %cLogger:', 'color: cyan', 'color: yellow', eventInput, eventProperties);
      }
    });

    // integrated with Google GTM
    if (Array.isArray(dataLayer)) {
      (dataLayer as any).push({ event: 'logEvent', eventType: eventInput, eventProperties });
    }
  }

  setUser(userId: string, email: string, createdDate: string): void {
    if (isDev) {
      console.log(
        "%c[Dev] %cAmpitude's user data has been set up.",
        'color: cyan',
        'color: magenta',
        userId,
        email,
        createdDate
      );
    }
    amplitude.setUserId(userId);

    const identifyObj = new amplitude.Identify();
    identifyObj.setOnce('Email', email);
    identifyObj.setOnce('Created Date', createdDate);

    amplitude.identify(identifyObj);

    if (Array.isArray(dataLayer)) {
      (dataLayer as any).push({ event: 'setUserId', userId });
      (dataLayer as any).push({
        event: 'setUserProperties',
        userProperties: { Email: email, 'Created Date': createdDate },
      });
    }
  }

  clear(): void {
    if (isDev) {
      console.log("%c[Dev] %cAmpitude's user data has been cleared now.", 'color: cyan', 'color: magenta');
    }
    amplitude.reset();
  }

  ga(eventInput: string, eventProperties: Record<string, any> = {}): void {
    if (typeof (window as any).gtag !== 'function') {
      console.error('No google tag manager');
      return;
    }

    (window as any).gtag('event', eventInput, {
      send_to: 'AW-10975082955/poh8CN_IytsDEMvzqfEo',
      ...eventProperties,
    });
  }

  lintrk(): void {
    if (typeof (window as any).lintrk !== 'function') {
      console.error('No LinkedIn insight tag');
      return;
    }

    (window as any).lintrk('track', { conversion_id: 9605652 });
  }
}

export default new LoggerClass();
